module.exports = "router-outlet {\n  padding-top: 10px; }\n\npt-5 {\n  padding-top: 10px; }\n"